import { DirectSaleStatisticsResponse } from '@/core/domain/sales/DirectSale/DirectSale.types';
import { useChartTheme } from '@/hooks';
import { ResponsivePie } from '@nivo/pie';
import { Card, Typography } from 'antd';

interface Props {
  directSaleStatistics?: DirectSaleStatisticsResponse;
}

const DirectSalePrevisionChart: React.FC<Props> = ({
  directSaleStatistics: statistics,
}) => {
  const theme = useChartTheme();

  const format = (value = 0) =>
    value.toLocaleString('pt-br', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      style: 'percent',
    });

  return (
    <Card style={{ borderRadius: 4 }}>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        Venda direta prevista em %
      </Typography.Title>
      <div style={{ height: 300 }}>
        <ResponsivePie
          margin={{ top: 24, right: 100, bottom: 48, left: 100 }}
          sortByValue={true}
          innerRadius={0.5}
          padAngle={1}
          cornerRadius={4}
          activeOuterRadiusOffset={8}
          enableArcLabels={false}
          arcLinkLabelsSkipAngle={15}
          arcLinkLabel={(item) => `${item.label}: ${format(item.value / 100)}`}
          arcLinkLabelsColor={{ from: 'color' }}
          colors={['hsl(154, 70%, 50%)', 'hsl(200, 100%, 50%)']}
          valueFormat={(value) => format(value / 100)}
          data={[
            {
              id: 'Autorizados',
              label: 'Autorizados',
              value: statistics?.authorizedToOpenRatio,
              color: 'hsl(154, 70%, 50%)',
            },
            {
              id: 'Abertos',
              label: 'Abertos',
              value: statistics?.openToAuthorizedRatio,
              color: 'hsl(200, 100%, 50%)',
            },
          ]}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: 48,
              itemsSpacing: 0,
              itemWidth: 150,
              itemHeight: 18,
              itemDirection: 'left-to-right',
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: 'circle',
            },
          ]}
          theme={theme}
        />
      </div>
    </Card>
  );
};

export default DirectSalePrevisionChart;
